function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.7799 0.118502C6.1328 -0.158227 7.53705 0.0533107 8.75277 0.71539C9.54635 1.14757 10.2267 1.75373 10.75 2.48226C11.2733 1.75373 11.9537 1.14757 12.7472 0.71539C13.963 0.0533107 15.3672 -0.158227 16.7201 0.118502C18.0728 0.395187 19.2865 1.14196 20.1566 2.22744C21.0264 3.31258 21.5 4.66987 21.5 6.06819C21.5 9.88374 18.7814 13.2462 16.2579 15.5689C14.975 16.7498 13.6953 17.7048 12.7379 18.3642C12.2584 18.6943 11.858 18.9515 11.576 19.1271C11.4349 19.2149 11.3234 19.2823 11.2462 19.3283C10.8411 19.5697 10.6557 19.5678 10.2538 19.3283C10.1766 19.2823 10.0651 19.2149 9.924 19.1271C9.64199 18.9515 9.24156 18.6943 8.76213 18.3642C7.80468 17.7048 6.52502 16.7498 5.24207 15.5689C2.71863 13.2462 0 9.88374 0 6.06819C0 4.66987 0.473588 3.31258 1.34342 2.22744C2.21353 1.14196 3.42722 0.395187 4.7799 0.118502Z",
  fill: "white"
});

function SvgCommunityActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityActive);
export default __webpack_public_path__ + "static/media/community-active.2bdaea8c.svg";
export { ForwardRef as ReactComponent };